<!-- KPI tile: label, value, caption underneath. -->
<script lang="ts">
  import type { Snippet } from "svelte";
  let { label, value, sub }: { label: string; value: Snippet | string; sub?: Snippet | string | null } = $props();
</script>

<div class="kpi">
  <div class="label">{label}</div>
  <div class="value">{#if typeof value === "string"}{value}{:else}{@render value()}{/if}</div>
  {#if sub}<div class="sub">{#if typeof sub === "string"}{sub}{:else}{@render sub()}{/if}</div>{/if}
</div>
